import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { subscribeOn } from 'rxjs/operators';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { AlertService } from 'src/app/providers/alert.service';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserReportType } from 'src/app/shared/constants/user-report-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { PostProfileDetailsComponent } from '../../../shared/components/post-profile-details/post-profile-details.component';

import { SharedService } from '../../../providers/shared.service';


@Component({
  selector: 'sm-un-used-qr',
  templateUrl: './un-used-qr.component.html',
  styleUrls: ['./un-used-qr.component.scss']
})
export class UnUsedQRComponent implements OnInit {

 
  reportList: any[] = [];
  profileData: any
  clickEventSubscription: Subscription;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "QR Id",
      columnProperty: "qr_code"
    },
    {
      columnName: "Date",
      columnProperty: "creation_time"
    }
  ];
  private _apiSub: Subscription;
  private _apiSubscription: Subscription;
  public loader: boolean = false;

  constructor(private sharedService: SharedService,private _apiService : ApiService, private _datePipe: DatePipe, private _alertService: AlertService, private _dialog: MatDialog) { 
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    this._apiSub = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_UNUSED_QR_CODES_RESULT){
        console.log(resData);
      
        this.reportList = resData.result ? resData.result : [];
        this.reportList =     this.reportList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['creation_time'])) - (+new 
        Date(dataA['creation_time'])))
 
     )
        this.reportList.map(report => {
          report.creation_time = this._datePipe.transform(report.creation_time, 'MMM d, y');
        
        });
      }
      if(resData.responseType === SM_CONSTANTS.CREATE_QR_CODE_RESULT){
      
      this.ngOnInit();

      }
    
     this.loader = false
    });
    this._apiSubscription = new Subscription()
  }

  ngOnInit(): void {
    this.loader = true
    this._apiService.getUnUsedQRCodes()
  }

  onChangeContentStatus(status: 'block' | 'unblock', rowData: any){
    console.log(status, rowData);

    const requestInfo = {
      hash_id: rowData.hash_id,
      requestType: rowData.requestTypeInfo.requestType,
      requestToHash: rowData.requestTypeInfo.hash_id,
      requestStatus: status === 'block' ? 9 : 1
    }
    console.log(requestInfo);
    
    this._apiService.updateUserRequestStatus({requestInfo});
  }

  blockReported(rowvalue: any){

    // rowvalue.type = 'block'
    // this._dialog.open(BlockUnblockReportedComponent, {
    //   data: rowvalue,
      
    // })
  }

  unblockReported(rowvalue: any){
    // rowvalue.type = 'unblock'
    // this._dialog.open(BlockUnblockReportedComponent, {
    //   data: rowvalue,
      
    // })
  }

  viewDetails(rowvalue:any){
    console.log(rowvalue);
    this._dialog.open(PostProfileDetailsComponent, {
      data: rowvalue,
      width: '500px',
      panelClass: 'user-profile-dialog'
    });
    
  }
  createQRcode(){
    this.loader = true
    this._apiService.createQRcode()

  }


  ngOnDestroy(){
    this._apiSub.unsubscribe();
    this._apiSubscription.unsubscribe();
  }


}
